import React from 'react';
export function AnnouncementBar() {
  return <div className="w-full bg-brand-blue text-white text-center py-2 px-4 text-sm font-medium" data-id="element-20">
      🎓 Para Estudiantes de Medicina en Argentina · 3 Niveles disponibles
    </div>;
}